/* HOK · Collection behaviour (sections/hok-collection.liquid)
   - delivery promise from the section's cutoffs (Africa/Casablanca time, no Sunday), city remembered per visitor
   - title size fitted per row (one size per row, the largest that keeps every title on 2 lines) in 6 layout passes total
   - quick add through /cart/add.js, then the Kaching cart is refreshed and opened (fallback: native form post)
   - cart bar toward free shipping, "Voir plus" without reloading, filter sheet, search panel, sort on change */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const ls = { get: k => { try { return localStorage.getItem(k); } catch (_) { return null; } }, set: (k, v) => { try { localStorage.setItem(k, v); } catch (_) {} } };
  const mqDesk = window.matchMedia('(min-width: 990px)');

  function init(root) {
    if (!root || root.dataset.hokcReady) return;
    root.dataset.hokcReady = '1';
    const D = root.dataset;
    const FREE = (+D.free || 0) * 100, FEE = (+D.fee || 0) * 100;
    const moneyFormat = D.money || '{{amount}} Dhs';
    const money = cents => {
      const v = cents / 100;
      const fmt = (d, sep) => { const s = v.toFixed(d).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep === ',' ? '.' : ',') + (d ? (sep === ',' ? ',' : '.') + s[1] : ''); };
      const amount = Number.isInteger(v) ? String(v) : v.toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, fmt(0)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, fmt(2, ',')).replace(/\{\{\s*amount\s*\}\}/, amount);
    };

    /* ---------- delivery promise ---------- */
    const rules = { casa: D.casa.split(':').map(Number), other: D.other.split(':').map(Number) };
    let city = ls.get('hokc-city') === 'other' ? 'other' : 'casa';
    function eta(c) {
      const [h, m, days] = rules[c];
      const parts = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Africa/Casablanca', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      const g = t => +parts.find(p => p.type === t).value;
      const today = new Date(Date.UTC(g('year'), g('month') - 1, g('day')));
      const mins = g('hour') * 60 + g('minute'), cut = h * 60 + m;
      const skip = d => { if (D.sunday) while (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1); };
      const d = new Date(today);
      const sunday = !!D.sunday && d.getUTCDay() === 0;
      d.setUTCDate(d.getUTCDate() + (mins < cut && !sunday ? 0 : 1)); skip(d);
      for (let k = 0; k < days; k++) { d.setUTCDate(d.getUTCDate() + 1); skip(d); }
      const diff = Math.round((d - today) / 864e5);
      const day = diff === 0 ? "aujourd'hui" : diff === 1 ? 'demain' : d.toLocaleDateString('fr-FR', { weekday: 'long', timeZone: 'UTC' });
      const left = cut - mins;
      const hh = String(h).padStart(2, '0') + 'h' + (m ? String(m).padStart(2, '0') : '');
      const before = left > 0 && !sunday ? `Commandez avant ${hh}${left <= 180 ? ` (encore ${left >= 60 ? Math.floor(left / 60) + ' h ' + String(left % 60).padStart(2, '0') : left + ' min'})` : ''}` : 'Commandez maintenant';
      return { day, before };
    }
    function paintEta() {
      const e = eta(city);
      root.querySelectorAll('[data-city]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.city === city)));
      const html = `<b>${D.eta} ${e.day}</b><small>${e.before}</small>`;
      root.querySelectorAll('[data-hokc-when]').forEach(w => { if (w.innerHTML !== html) w.innerHTML = html; });
      const label = `${D.eta} ${e.day}`;
      root.querySelectorAll('[data-hokc-eta]').forEach(el => { if (el.textContent !== label) el.textContent = label; });
    }

    /* ---------- titles: one size per row, the largest that keeps every title on 2 lines.
       Batched: one write + one read per candidate size for the whole grid (6 layouts in total). ---------- */
    function fitTitles() {
      const titles = [...root.querySelectorAll('.hokc-card .hokc-title')];
      if (!titles.length) return;
      const sizes = mqDesk.matches ? [14, 13.5, 13, 12.5, 12] : [13, 12.5, 12, 11.5, 11];
      const rowOf = titles.map(t => t.closest('.hokc-card').offsetTop);           // read
      const fits = sizes.map(() => []);
      titles.forEach(t => { t.style.webkitLineClamp = 'unset'; t.style.display = 'block'; });
      sizes.forEach((s, i) => {
        titles.forEach(t => { t.style.fontSize = s + 'px'; });                     // write all
        titles.forEach((t, k) => { fits[i][k] = t.scrollHeight <= Math.ceil(s * 1.35 * 2) + 1; }); // read all
      });
      const rows = {};
      titles.forEach((t, k) => (rows[rowOf[k]] ??= []).push(k));
      const choice = new Array(titles.length);
      Object.values(rows).forEach(ks => {
        let i = sizes.findIndex((_, j) => ks.every(k => fits[j][k]));
        if (i < 0) i = sizes.length - 1;
        ks.forEach(k => { choice[k] = sizes[i]; });
      });
      titles.forEach((t, k) => { t.style.fontSize = choice[k] + 'px'; t.style.webkitLineClamp = ''; t.style.display = ''; });
    }

    /* ---------- second photo dots ---------- */
    function wireSlides(scope) {
      scope.querySelectorAll('[data-hokc-slides]').forEach(sl => {
        const dots = sl.parentElement.querySelectorAll('.hokc-dots i');
        if (!dots.length || sl.dataset.wired) return;
        sl.dataset.wired = '1';
        sl.addEventListener('scroll', () => { const i = Math.round(sl.scrollLeft / sl.clientWidth); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }, { passive: true });
      });
    }

    /* ---------- the toolbar sticks under the theme's sticky header; the value is written only when it changes ---------- */
    const header = document.querySelector('sticky-header, .section-header');
    const headerSection = header && (header.closest('.shopify-section') || header);
    let lastTop = -1, ticking = false;
    function stickTop() {
      ticking = false;
      let top = 0;
      if (headerSection) {
        const pos = getComputedStyle(headerSection).position;
        if (pos === 'sticky' || pos === 'fixed') top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      }
      if (top !== lastTop) { lastTop = top; root.style.setProperty('--hokc-sticky-top', top + 'px'); }
    }
    if (headerSection) window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(stickTop); } }, { passive: true });

    /* ---------- cart ---------- */
    const getCart = () => fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    async function openCart() {
      const k = window.kachingCartApi;
      if (k && typeof k.refreshCart === 'function') {
        try { await k.refreshCart(); } catch (_) {}
        if (typeof k.openCart === 'function') { k.openCart(); return true; }
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return false;
    }
    function paintDock(cart) {
      const dock = root.querySelector('[data-hokc-dock]');
      if (!dock) return;
      const total = cart.total_price, count = cart.item_count;
      dock.hidden = !count;
      if (!count) return;
      const left = Math.max(0, FREE - total);
      dock.querySelector('[data-hokc-dock-msg]').innerHTML = (left > 0 ? `Plus que ${money(left)} pour la livraison offerte` : 'Livraison offerte sur ce panier') + `<span>${count} article${count > 1 ? 's' : ''} · ${money(total)}</span>`;
      dock.querySelector('[data-hokc-meter]').style.width = Math.min(100, Math.round(total / FREE * 100)) + '%';
      dock.querySelector('[data-hokc-total]').textContent = money(total + (left > 0 ? FEE : 0));
      const fill = dock.querySelector('[data-hokc-fill]');
      const inCart = new Set(cart.items.map(i => String(i.variant_id)));
      const pick = left > 0 ? [...root.querySelectorAll('.hokc-card[data-single="1"]')]
        .map(c => ({ c, price: +c.dataset.price })).filter(o => o.price >= left && !inCart.has(o.c.dataset.variant))
        .sort((a, b) => a.price - b.price)[0] : null;
      fill.hidden = !pick;
      if (pick) {
        const c = pick.c.dataset;
        fill.innerHTML = `${c.img ? `<img src="${c.img}" alt="" width="44" height="44" loading="lazy">` : '<span></span>'}<div><b>${c.title}</b>${money(pick.price)}. Avec cet article, la livraison est offerte.</div><button type="button" data-hokc-fill-add="${c.variant}">Ajouter</button>`;
      }
    }
    async function add(variant, btn) {
      if (btn) { if (btn.classList.contains('is-busy')) return; btn.classList.add('is-busy'); }
      try {
        const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +variant, quantity: 1 }] }) });
        if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Ajout impossible');
        if (btn) { btn.classList.add('is-added'); const l = btn.querySelector('.hokc-btn__label'); if (l) { l.dataset.label = l.dataset.label || l.textContent; l.textContent = D.added; } }
        paintDock(await getCart());
        await openCart();
      } catch (err) {
        if (btn) { const l = btn.querySelector('.hokc-btn__label'); const old = l && l.textContent; if (l) l.textContent = err.message; setTimeout(() => { if (l) l.textContent = old; }, 2500); }
      } finally { if (btn) btn.classList.remove('is-busy'); }
    }

    // buttons follow the real cart: an item removed in the Kaching cart turns its button back to "Ajouter"
    function syncButtons(cart) {
      const ids = new Set(cart.items.map(i => String(i.variant_id)));
      root.querySelectorAll('.hokc-card').forEach(c => {
        const b = c.querySelector('form .hokc-btn');
        if (!b || b.classList.contains('is-busy')) return;
        const l = b.querySelector('.hokc-btn__label');
        const on = ids.has(c.dataset.variant);
        if (on && !b.classList.contains('is-added')) { b.classList.add('is-added'); if (l) { l.dataset.label = l.dataset.label || l.textContent; l.textContent = D.added; } }
        else if (!on && b.classList.contains('is-added')) { b.classList.remove('is-added'); if (l && l.dataset.label) l.textContent = l.dataset.label; }
      });
    }
    let syncT;
    const scheduleSync = () => { clearTimeout(syncT); syncT = setTimeout(() => getCart().then(c => { syncButtons(c); paintDock(c); }).catch(() => {}), 250); };
    if (!window.__hokcCartWatch) {
      // Kaching changes the cart with fetch('/cart/update.js'); listen without changing the request or its response
      window.__hokcCartWatch = true;
      const re = /\/cart\/(add|change|update|clear)(\.js)?/;
      const notify = () => document.dispatchEvent(new CustomEvent('hokc:cart-changed'));
      const of = window.fetch;
      window.fetch = function (input) {
        const p = of.apply(this, arguments);
        try { const u = typeof input === 'string' ? input : (input && input.url) || ''; if (re.test(u)) p.then(notify, () => {}); } catch (_) {}
        return p;
      };
      const oo = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) { try { if (re.test(String(u))) this.addEventListener('loadend', notify); } catch (_) {} return oo.apply(this, arguments); };
    }
    document.addEventListener('hokc:cart-changed', scheduleSync);
    window.addEventListener('pageshow', e => { if (e.persisted) scheduleSync(); });

    /* ---------- events ---------- */
    const closeFilters = p => { p.classList.remove('is-open'); document.documentElement.style.overflow = ''; root.querySelector('[data-hokc-open-filters]')?.focus(); };
    root.addEventListener('submit', e => {
      const f = e.target.closest('[data-hokc-form]');
      if (!f) return;
      e.preventDefault();
      add(f.querySelector('[name="id"]').value, f.querySelector('.hokc-btn'));
    });
    root.addEventListener('click', e => {
      const cityBtn = e.target.closest('[data-city]');
      if (cityBtn) { city = cityBtn.dataset.city; ls.set('hokc-city', city); paintEta(); return; }
      const fillAdd = e.target.closest('[data-hokc-fill-add]');
      if (fillAdd) { add(fillAdd.dataset.hokcFillAdd, null); return; }
      if (e.target.closest('[data-hokc-go]') && window.kachingCartApi) { e.preventDefault(); openCart(); return; }
      const sBtn = e.target.closest('[data-hokc-search]');
      if (sBtn) {
        const panel = root.querySelector('[data-hokc-searchpanel]');
        const open = panel.hidden;
        panel.hidden = !open; sBtn.setAttribute('aria-expanded', String(open));
        if (open) panel.querySelector('input[type="search"]').focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-hokc-open-filters]')) { const p = root.querySelector('[data-hokc-filters]'); p.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; p.querySelector('.hokc-x')?.focus(); return; }
      const fp = e.target.closest('[data-hokc-filters]');
      if (fp && (e.target === fp || e.target.closest('[data-hokc-close-filters]'))) { closeFilters(fp); return; }
      const next = e.target.closest('[data-hokc-next]');
      if (next) { e.preventDefault(); loadMore(next); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { const p = root.querySelector('[data-hokc-filters].is-open'); if (p) closeFilters(p); } });
    root.querySelector('[data-hokc-sort]')?.addEventListener('change', e => e.target.form.submit());
    // desktop: a filter change applies at once
    root.querySelector('[data-hokc-filter-form]')?.addEventListener('change', e => { if (mqDesk.matches && e.target.type === 'checkbox') e.currentTarget.submit(); });

    /* ---------- load more (section rendering, no reload) ---------- */
    async function loadMore(btn) {
      btn.classList.add('is-busy');
      try {
        const url = new URL(btn.href, location.href);
        url.searchParams.set('section_id', D.section);
        const html = await fetch(url).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = root.querySelector('[data-hokc-grid]');
        const frag = document.createDocumentFragment();
        doc.querySelectorAll('.hokc-card').forEach(c => frag.appendChild(document.importNode(c, true)));
        grid.appendChild(frag);
        const more = doc.querySelector('[data-hokc-more]');
        root.querySelector('[data-hokc-more]').replaceWith(document.importNode(more || document.createElement('div'), true));
        paintEta(); wireSlides(root); fitTitles(); scheduleSync();
      } catch (_) { location.href = btn.href; }
    }

    paintEta(); fitTitles(); stickTop();
    (window.requestIdleCallback || setTimeout)(scheduleSync);
    requestAnimationFrame(() => wireSlides(root));
    if (document.fonts && document.fonts.status !== 'loaded') document.fonts.ready.then(fitTitles);
    let rt; mqDesk.addEventListener('change', fitTitles);
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { fitTitles(); stickTop(); }, 200); });
    getCart().then(paintDock).catch(() => {});
    setInterval(paintEta, 60000);
  }

  const boot = () => document.querySelectorAll('.hokc').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
